import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChromecast: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChromecast"><Path d="M2.5 3.5V3H2V3.5H2.5ZM21.5 3.5H22V3H21.5V3.5ZM21.5 20.5V21H22V20.5H21.5ZM16.5 20H16V21H16.5V20ZM2 6.5V7H3V6.5H2ZM2 14C5.86599 14 9 17.134 9 21H10C10 16.5817 6.41828 13 2 13V14ZM2 10C8.07513 10 13 14.9249 13 21H14C14 14.3726 8.62742 9 2 9V10ZM2.5 4H21.5V3H2.5V4ZM21 3.5V20.5H22V3.5H21ZM21.5 20H16.5V21H21.5V20ZM2 3.5V6.5H3V3.5H2ZM2 18C3.65685 18 5 19.3431 5 21H6C6 18.7909 4.20914 17 2 17V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChromecast;
